module.exports = __webpack_public_path__ + "c4a071fb77d1d5b4de6bbf591accda7b.MP3";